import Vue from 'vue';

import useToggleState from 'composables/useToggleState';

import Component from 'vue-class-component';
import arrow from 'assets/icons/Chevron.svg';

@Component({
  props: {
    options: {
      type: Array,
      required: true,
    },
    orderDescription: {
      type: String,
      required: false,
      default: 'Ordenar por',
    },
    productType: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup() {
    const {
      showMenu: showList,
      toggleMenu: toggleShowList,
      refToggleState,
    } = useToggleState();

    return {
      showList,
      toggleShowList,
      refToggleState,
    };
  },
})
export default class OrderDropdownComponent extends Vue {
  icons = {
    arrow,
  };
  selectedOrder = this.options[0];

  isSelected(option) {
    return option === this.selectedOrder.title;
  }

  updateSort() {
    this.$emit('updateFilter', {
      filter: 'sort',
      option: null,
      sort: this.selectedOrder.value,
      product: this.productType,
    });
  }

  selectOrder(option) {
    this.selectedOrder = option;
    this.updateSort();
    this.toggleShowList();
  }
}
